import { LocalStorageKey } from 'shared/constants/localStorage'
import { lsGetItem } from 'shared/utils/local-storage'
import { lsGetUserItem } from 'shared/utils/local-storage/lsGetUserItem'
import { lsSetUserItem } from 'shared/utils/local-storage/lsSetUserItem'

import { initFilesSdk } from './filesSdk'

/**
 * Returns the desktop's root app folder id for the current session.
 *
 * Resolves once per user: the id returned by the SDK's `setupAppFolder` is
 * persisted user-scoped in localStorage and reused on every subsequent call,
 * so we never hit the endpoint again until the user logs out (which clears the
 * stored id). When the id is missing it is fetched once and persisted.
 */
export const getAppFolderId = async (): Promise<number | null> => {
  const user = lsGetItem(LocalStorageKey.USER)
  if (!user?.id) return null

  const userId = user.id.toString()
  const cachedId = lsGetUserItem(LocalStorageKey.DESKTOP_APP_FOLDER_ID, userId)
  if (cachedId != null) return cachedId

  const { filesSdk, success } = initFilesSdk()
  if (!success || !filesSdk) return null

  const folderId = await filesSdk.folders.setup()
  lsSetUserItem(LocalStorageKey.DESKTOP_APP_FOLDER_ID, userId, folderId)

  return folderId
}
